import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { useHasAcademyOnboardingAccess } from '../hasAcademyOnboardingAccess';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const HasAcademyOnboardingAccess = ({
  fallback = /*#__PURE__*/_jsx(_Fragment, {}),
  children
}) => {
  const {
    hasAccess,
    isLoading
  } = useHasAcademyOnboardingAccess();
  if (isLoading) return /*#__PURE__*/_jsx(LoadingSpinner, {
    grow: true,
    layout: "centered",
    margin: "400"
  });
  if (hasAccess) return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: fallback
  });
};